class LocationsController {
  constructor() {

  }
}

export default LocationsController;
